import type { SVGProps } from 'react';
const DawnFlagLY = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-LY_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-LY_svg__a)">
      <g filter="url(#dawn-flag-LY_svg__b)">
        <path
          fill="#262626"
          fillRule="evenodd"
          d="M0 10.667h22V5.333H0z"
          clipRule="evenodd"
        />
      </g>
      <g filter="url(#dawn-flag-LY_svg__c)">
        <path
          fill="#34B857"
          fillRule="evenodd"
          d="M0 16h22v-5.333H0z"
          clipRule="evenodd"
        />
      </g>
      <path fill="#F41F34" fillRule="evenodd" d="M0 5.333h22V0H0z" clipRule="evenodd" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M11 9.6c.323 0 .624-.1.873-.27l-.087.003c-.723 0-1.31-.597-1.31-1.333a1.32 1.32 0 0 1 1.397-1.33c-.25-.17-.55-.27-.873-.27-.868 0-1.571.716-1.571 1.6S10.132 9.6 11 9.6M12.572 8a.53.53 0 0 1-.524.533.53.53 0 0 1-.524-.533c0-.295.235-.533.524-.533s.524.238.524.533"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <filter
        id="dawn-flag-LY_svg__b"
        width={22}
        height={5.333}
        x={0}
        y={5.333}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_88_1096" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_88_1096" result="shape" />
      </filter>
      <filter
        id="dawn-flag-LY_svg__c"
        width={22}
        height={5.333}
        x={0}
        y={10.667}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_88_1096" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_88_1096" result="shape" />
      </filter>
    </defs>
  </svg>
);
export default DawnFlagLY;
